import React from 'react';
import { Form, Input, Modal, Button } from 'antd';
const FormItem = Form.Item;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const Search = Input.Search;
import { SgiEventHandler } from './SgiEventHandler'
class SgiFormInputSearch extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        //初始化state属性
        this.initState();
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    inputSearch_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops, objFct);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        // this.bindValue(moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, objFct, type);
    }

    // bindValue(moduleDesc, bdInst, objFct, formItem, inputprops) {
    //     if (!bdInst || !moduleDesc.c || !objFct) {
    //         return;
    //     }
    //     //currentModule.bdInst = bdInst;
    //     var attname = moduleDesc.c;
    //     this.state.attname = attname;
    //
    //     // var bdInstValue = objFct.get(bdInst);
    //     // inputprops.value = "显示值";//bdInstValue[attname];
    // }

    /**
     * 绑定事件
     * @param  {[type]} moduleDesc    [description]
     * @param  {[type]} formItemProps [description]
     * @param  {[type]} inputprops    [description]
     * @param  {[type]} functions     [description]
     * @param  {[type]} objFct        [description]
     * @return {[type]}               [description]
     */
    bindEvent(moduleDesc, formItemProps, inputprops, functions, objFct, type) {
        //加入通用的进入、修改、离开事件
        bindEvent(this, moduleDesc, formItemProps, inputprops, functions, type);

        var isCustom = moduleDesc.isCustom;//true:自定义
        var uid = moduleDesc.uid;
        if (!isCustom) {//非自定义
            moduleDesc.clkLsn = `tool.popUI("${uid}", objFct);`;
        }
        var iCLsn = moduleDesc.clkLsn; // 用户自定义点击事件
        if (iCLsn) {
            var $iCLsn = new Function("module", "objFct", "value", iCLsn);
            functions.onSearch = $iCLsn;
        }
        inputprops.onSearch = SgiEventHandler.onSearch.bind(this);
    }

    clearValue() {
        this.state.bindData = undefined;
        this.setValue('', '');
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops, objFct) {
        // var isCustom = moduleDesc.isCustom;//true:自定义
        // var clkLsn = moduleDesc.clkLsn;//点击事件
        // var uid = moduleDesc.uid;
        // if(isCustom && clkLsn){
        //   inputprops.onSearch = (value) => {
        //     eval(clkLsn);
        //   }
        // }else if (!isCustom) {
        //   inputprops.onSearch = (value) => {
        //     window.tool.popUIByUid(uid, objFct);
        //   }
        // }
    }


    //渲染并返回一个虚拟
    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.inputSearch_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.state.inputprops.showValue = this.state.inputprops.value;
            this.loaded = true;
        }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        //设置删除功能，如果value存在，显示删除按钮
        if (this.state.inputprops.value) {
            this.state.inputprops.suffix = <Button size={"small"} onClick={this.clearValue.bind(this)} style={{ border: 'none' }} icon={"delete"} />
        } else {
            this.state.inputprops.suffix = undefined;
        }

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} title={this.state.inputprops.showValue}>{this.state.inputprops.showValue}</span>
            : <Search {...this.state.inputprops} {..._inputProps} value={this.state.inputprops.showValue} />;

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }
}

//给类添加公共方法
Object.assign(SgiFormInputSearch.prototype, sgiFormCtlBaseFun);

SgiFormInputSearch.prototype.setValueByBindData = function (bindData, valueKey, showKey) {
    if (!bindData || !valueKey || !showKey) return;
    this.state.bindData = bindData;

    let value;
    let showValue;
    if (bindData instanceof Array){
        bindData.forEach((element,index) => {
            
            if (index  === 0){
                value = element[valueKey]
                showValue = element[showKey]
            } else {
                value = value + "," +  element[valueKey]
                showValue = showValue + "," +  element[showKey]
            }
        });
    } else {
        value = bindData[valueKey];
        showValue = bindData[showKey];
    }
    this.setValue(value,showValue);
}

SgiFormInputSearch.prototype.getBindData = function () {
    return this.state.bindData
}

//方法特殊  重写setValue方法
SgiFormInputSearch.prototype.setValue = function (value, showValue) {
    // tool.sgiLogger.log(arguments.length);
    if (arguments.length === 2) {
        // showValue = this.state.inputprops.showValue || value;
        this.state.inputprops.showValue = showValue;
    } else {
        this.state.inputprops.showValue = this.state.inputprops.showValue || value;
    }
    this.state.inputprops.value = value;

    //页面校验
    // this.validate(value);//刷新时不进行校验
    this.setState({});

    var { moduleDesc, bdInst, objFct, type } = this.props;
    let attname = moduleDesc.c

    //刷新对象工厂值
    //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
    //通过type区分，type==tb时候为表格控件，其他时候为普通控件
    var bdInstValue;
    if (bdInst && attname) {
        if (typeof bdInst === "string") {
            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
            if (type === 'tb') {
                const bdInstKeyList = bdInst.split('`');
                const bdInstList = objFct.get(bdInstKeyList[0]);
                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                    bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
                }
            } else {
                bdInstValue = objFct.get(bdInst);
            }
        } else {
            bdInstValue = bdInst;
        }
    }

    if (bdInstValue) {
        bdInstValue[attname] = value;
    }

}

export { SgiFormInputSearch };
export default SgiFormInputSearch;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormInputSearch.js